<template>
  <div class='newplace full_layout'>
    <img src="/static/images/activty/tradingrules/tradingrules_01.png">
    <img src="/static/images/activty/tradingrules/tradingrules_02.png">
    <img src="/static/images/activty/tradingrules/tradingrules_03.png">
  </div>
</template>
<script>
import bus from '@/api/bus';
export default {
  name: '',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.tradingRules'));
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/tradingrules.vue